// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"118":"85df73199dc5526a","4277":"253cd4940ee8997c","7737":"d9d19245f287c2bb","7849":"0e4dd22b9570e784"}[chunkId] + ".js";
};